var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommunityServicePin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.108,
    height: 71.633,
    viewBox: "0 0 54.108 71.633",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4421",
    x: 0,
    y: 0,
    width: 54.108,
    height: 71.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807",
    transform: "translate(17632 14683.634)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(-17623 -14677.634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 13.721,
    cy: 13.721,
    r: 13.721,
    transform: "translate(4.364 4.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4421-2",
    "data-name": "Path 4421",
    d: "M18.054,0A18.054,18.054,0,0,0,0,18.054c0,9.971,18.054,35.579,18.054,35.579S36.108,28.025,36.108,18.054A18.054,18.054,0,0,0,18.054,0m0,30.965A12.911,12.911,0,1,1,30.965,18.054,12.911,12.911,0,0,1,18.054,30.965",
    transform: "translate(9 6)",
    fill: "#047BC1"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hand-holding-heart",
    transform: "translate(-17612.365 -14666.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4502",
    "data-name": "Path 4502",
    d: "M142.418,7.126a1.987,1.987,0,0,0,0,2.782l2.617,2.658a.815.815,0,0,0,1.159,0l2.617-2.658a1.987,1.987,0,0,0,0-2.782,1.919,1.919,0,0,0-2.741,0l-.456.464-.456-.464A1.919,1.919,0,0,0,142.418,7.126Z",
    transform: "translate(-138.196 -6.55)",
    fill: "#888",
    opacity: 0.795
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4503",
    "data-name": "Path 4503",
    d: "M14.418,321.86A1.03,1.03,0,0,0,13.2,320.2l-3.084,2.272H7.007a.412.412,0,0,1,0-.824H9.068a.824.824,0,1,0,0-1.649H4.99a3.306,3.306,0,0,0-2.061.721l-1.157.927H.824a.823.823,0,0,0-.824.824v1.649a.823.823,0,0,0,.824.824H9.08a3.512,3.512,0,0,0,2.079-.683l3.261-2.4Zm-9.431-.214a.013.013,0,1,1-.007-.014A.013.013,0,0,1,4.987,321.646Z",
    transform: "translate(0 -311.925)",
    fill: "#047BC1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommunityServicePin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Community-service-pin.8f3dffc263efa400cb08c7af47dd3c51.svg";